export default __webpack_public_path__ + "static/1336-534815c2eccca428dd1acc5e7f02db72.gif";